import { useEffect, useState } from 'react';


import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { confirmDialog } from 'primereact/confirmdialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import logo from '../assets/img/user.png';
import { useAuth } from './Context/AuthContext';
import './Sidebar.css';
import { UserDataStorage } from './Storage/UserDataStorage';
import { useToast } from './hook/useToast';

interface StateSidebarProps {
  state: boolean;
}

const Sidebar = ({state}: StateSidebarProps)=>{

    // const toast = useRef(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();
    const [showSpinner, setShowSpinner] = useState(false);

    const [userName, setUserName] = useState<String>("");

    const { logout } = useAuth();

    // function getStoredUserData(): User | null {
    //     // Obtener la cadena JSON del localStorage
    //     const storedDataString = UserDataStorage.get();
      
    //     // Verificar si hay datos almacenados
    //     if (storedDataString) {
    //       try {
    //         // Intentar convertir la cadena JSON a un objeto
    //         const storedDataObject = storedDataString;
    //         return storedDataObject;
    //       } catch (error) {
    //         // Manejar errores de análisis JSON
    //         console.error('Error al analizar JSON:', error);
    //         return null;
    //       }
    //     } else {
    //       // Si no hay datos almacenados, devolver null
    //       return null;
    //     }
    //   }

    // function deleteStoredUserData() {
    //     UserDataStorage.clear();
    //     window.location.href = "/login";
    // }
      
    // Ejemplo de uso
    let userData = UserDataStorage.get();
      
    useEffect(() => {
    //     if (userData) {
        
    //     console.log('Datos del usuario:', userData.userName);
    //   } else {
    //     console.log('No hay datos almacenados en localStorage.');
    //   }
    }, [userData]);

    const confirmExit = () => {
    
            confirmDialog({
                message: '¿Quieres salir de la aplicación?',
                header: 'Salir',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Si',
                rejectLabel: 'No',
                accept: () => accept(),
                reject
            });
        };
    
        
        const accept = async () => {

            setShowSpinner(true);
          
             setTimeout(() => {
                 logout();
            }, 3000);
            
          
        }

        const reject = () => {
              showWarn("Rechazada", "has rechazado!");
        }

        // const show = (severity: any, summary: any, detail: any) => {
        //     // @ts-ignore
        //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
        // };


    return (
        <>
        {
            showSpinner &&
            <div className="progressSpinner">
                <ProgressSpinner />
            </div>
        }
         
        <div className={"sidebar show"+state}>
            {/* <Toast ref={toast} /> */}
            <div className="sidebar-scroll">
                <div className="user-account">
                    <img src={logo} className="rounded-circle user-photo" alt="User Profile Picture" />
                    <div className="dropdown d-inline-block ps-2">
                        <span>Bienvenido,</span>
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {userData?.userInfo.firtsName} {userData?.userInfo.lastName}
                        </a>
                        <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#">Perfil</a></li>
                            <li><a className="dropdown-item" href="#">Cambiar contraseña</a></li>
                            <li><hr className="dropdown-divider" /></li>
                            <li><button className="dropdown-item" onClick={()=> confirmExit()}>Salir</button></li>
                        </ul>
                    </div>
                </div>
                <hr></hr>
                <div className="tab-content">
                    <nav className="sidebar-nav">
                        <ul className="accordion accordion-flush list-menu" id="accordionListMenu">
                            <li className="accordion-item">
                                <h2>
                                <a href="/home" className="accordion-button-no-content">
                                    <FontAwesomeIcon icon={icon({name: 'home'})} />&nbsp;&nbsp;Dashboard
                                </a>
                                </h2>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading1">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse1" aria-expanded="false" aria-controls="flush-collapse1">
                                    <FontAwesomeIcon icon={icon({name: 'cube'})} />&nbsp;&nbsp;Productos
                                </button>
                                </h2>
                                <div id="flush-collapse1" className="accordion-collapse collapse" aria-labelledby="flush-heading1" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/products"> Ver Productos</a></li>
                                            <li><a href="/new-product"> Nuevo</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading2">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse2" aria-expanded="false" aria-controls="flush-collapse2">
                                    <FontAwesomeIcon icon={icon({name: 'list'})} />&nbsp;&nbsp;Ordenes
                                </button>
                                </h2>
                                <div id="flush-collapse2" className="accordion-collapse collapse" aria-labelledby="flush-heading2" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/orders"> Ver Ordenes</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading3">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse3" aria-expanded="false" aria-controls="flush-collapse3">
                                    <FontAwesomeIcon icon={icon({name: 'user-gear'})} />&nbsp;&nbsp;Clientes
                                </button>
                                </h2>
                                <div id="flush-collapse3" className="accordion-collapse collapse" aria-labelledby="flush-heading3" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/customer"> Ver Clientes</a></li>
                                            {/* <li><a href="/new-product"> Nuevo</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading4">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse4" aria-expanded="false" aria-controls="flush-collapse4">
                                    <FontAwesomeIcon icon={icon({name: 'user-plus'})} />&nbsp;&nbsp;Usuarios
                                </button>
                                </h2>
                                <div id="flush-collapse4" className="accordion-collapse collapse" aria-labelledby="flush-heading4" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/users"> Ver usuarios</a></li>
                                            {/* <li><a href="/new-product"> Nuevo</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading5">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse5" aria-expanded="false" aria-controls="flush-collapse5">
                                    <FontAwesomeIcon icon={icon({name: 'book'})} />&nbsp;&nbsp;Libros de reclamaciones
                                </button>
                                </h2>
                                <div id="flush-collapse5" className="accordion-collapse collapse" aria-labelledby="flush-heading5" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/libro-reclamaciones"> Ver Libros</a></li>
                                            {/* <li><a href="/new-product"> Nuevo</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            
                            {/* <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading5">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse5" aria-expanded="false" aria-controls="flush-collapse5">
                                    <FontAwesomeIcon icon={icon({name: 'location-dot'})} />&nbsp;&nbsp;Ubigeo
                                </button>
                                </h2>
                                <div id="flush-collapse5" className="accordion-collapse collapse" aria-labelledby="flush-heading5" data-bs-parent="#accordionListMenu">
                                <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
                                </div>
                            </li> */}
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading6">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse6" aria-expanded="false" aria-controls="flush-collapse6">
                                    <FontAwesomeIcon icon={icon({name: 'sitemap'})} />&nbsp;&nbsp;Categorías
                                </button>
                                </h2>
                                <div id="flush-collapse6" className="accordion-collapse collapse" aria-labelledby="flush-heading6" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/category"> Ver categorías</a></li>
                                            <li><a href="/subcategory"> Ver subcategorías</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading7">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse7" aria-expanded="false" aria-controls="flush-collapse7">
                                        <FontAwesomeIcon icon={icon({name: 'palette'})} />&nbsp;&nbsp;Colores y Marcas
                                    </button>
                                </h2>
                                <div id="flush-collapse7" className="accordion-collapse collapse" aria-labelledby="flush-heading7" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/colors"> Ver Colores</a></li>
                                            <li><a href="/brands"> Ver Marcas</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading8">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse8" aria-expanded="false" aria-controls="flush-collapse7">
                                        <FontAwesomeIcon icon={icon({name: 'image'})} />&nbsp;&nbsp;Ofertas y promociones
                                    </button>
                                </h2>
                                <div id="flush-collapse8" className="accordion-collapse collapse" aria-labelledby="flush-heading8" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/banner-form"> Crear Banners</a></li>
                                            <li><a href="/modal-form"> Crear Modals</a></li>
                                            <li><a href="/type-offers">Crear Ofertas</a></li>
                                             <li><a href="/promo-bar-form">Crear Cintillo</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="accordion-item">
                                <h2 className="accordion-header" id="flush-heading9">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse9" aria-expanded="false" aria-controls="flush-collapse9">
                                        <FontAwesomeIcon icon={icon({name: 'truck'})} />&nbsp;&nbsp;Envíos
                                    </button>
                                </h2>
                                <div id="flush-collapse9" className="accordion-collapse collapse" aria-labelledby="flush-heading9" data-bs-parent="#accordionListMenu">
                                    <div className="accordion-body">
                                        <ul>
                                            <li><a href="/shipping"> Ver tarifas de envío</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </nav>    
                </div>
            </div>
        </div>
        </>
    );
}

export default Sidebar;